module.exports = __webpack_public_path__ + "static/img/bg_item_2.f702fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_item_2.png
// module id = +ECF
// module chunks = 1